import uuid from 'uuid/v1';

export default [
  {
    id: '1',
    Username: 'Afrogh',
    Name: 'امیر',
    Family: 'افروغ',
    Pass:'11111',
    Gender:'men',
    Phone:'789',
  },
  {
    id: '2',
    Username: 'Asadi',
    Name: 'حسین',
    Family: 'اسدی',
    Pass:'11111',
    Gender:'men',
    Phone:'456',
  },
  {
    id: '3',
    Username: 'RaadAbadi',
    Name: 'علی',
    Family: 'رعدآبادی',
    Pass:'4444',
    Gender:'men',
    Phone:'123',
  },
  
  
];
